'use client';

import { HStack, Link, Image, ImageProps, StackProps } from '@chakra-ui/react';
import { BetaLabel } from '~/components/ui/labels/BetaLabel';
import { useAgency } from '~/hooks/useAgency';
import { useUser } from '~/hooks/useUser';
import { getRoleLabel, isBrokerOrAdmin } from '~/lib/roles';
import { isBetaEnv } from '~/lib/utils';

interface LogoProps extends StackProps {
  imageProps?: ImageProps;
}

export function Logo({ imageProps, ...props }: LogoProps) {
  const { agency, theme, getLogoSrc } = useAgency();
  const { user } = useUser();

  return (
    <HStack
      alignItems="center"
      pr={4}
      // Manually fix EO's logo alignment
      mx={{ mobile: 0, desktop: agency?.id === 1 ? '-2' : '0' }}
      mb={{ mobile: 0, desktop: agency?.id === 1 ? '-3' : '0' }}
      pt={{ mobile: agency?.id === 1 ? '2' : '0', desktop: 0 }}
      {...props}
    >
      <Link href="/">
        <HStack alignItems="flex-start" spacing={0}>
          <Image
            src={getLogoSrc()}
            maxW={{ mobile: '100px', desktop: theme?.logo_max_width }}
            {...imageProps}
          />
          {(isBetaEnv || isBrokerOrAdmin(user)) && (
            <BetaLabel label={getRoleLabel(user)} />
          )}
        </HStack>
      </Link>
    </HStack>
  );
}
